import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery, getUrl} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {InfoCreateDTO, InfoDTO, InfoEditDTO} from "../../types/utils/InfoDTO";
import {DeleteParams} from "../../types/utils/Constants";

export const producerApi = createApi({
    reducerPath: "producer",
    baseQuery: apiQuery,
    tagTypes: ["producers"],
    endpoints: builder => ({
        getProducer: builder.query<Response<InfoDTO[]>, Partial<number | undefined>>({
            query: (accountId) => getUrl('/producers', [{name: "account_id", value: accountId}]),
            providesTags: ['producers']
        }),
        createProducer: builder.mutation <void, Partial<InfoCreateDTO>>({
            query: (body) => ({
                url: "/producers",
                method: "POST",
                body
            }),
            invalidatesTags: ["producers"]
        }),
        editProducer: builder.mutation <void, Partial<InfoEditDTO>>({
            query: (body) => ({
                url: `/producers/${body.id}`,
                method: "PATCH",
                body
            }),
            invalidatesTags: ["producers"]
        }),
        deleteProducer: builder.mutation <void, Partial<DeleteParams>>({
            query: (params) => ({
                url: getUrl(`/producers/${params.id}`, [{name: "account_id", value: params.accountId}]),
                method: "DELETE"
            }),
            invalidatesTags: ["producers"]
        }),
    })
})

export const {
    useGetProducerQuery,
    useCreateProducerMutation,
    useEditProducerMutation,
    useDeleteProducerMutation
} = producerApi
